import React from 'react';
import SkynetIcon from './Fundamentals/SkynetIcon';

const PastActionInfo = ({date, sender}) => {
    return <span className="pastActionInfo"><SkynetIcon icon='vismaicon-sm vismaicon-info' title={`Sent at ${date} by ${sender}`}/></span>;
}

export default PastActionInfo;